import axios from 'axios'

export function uploadCoverImage(data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/hubs/-actions/file-upload', data, {
        headers: {
            'Content-Type': 'multipart/form-data'
        },
    })
}

export function createHub(data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/hubs', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        }
    })
}

export function getHubs(spaceID, page, size) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceID + '/hubs?page[size]=' + size + '&page[number]=' + page + '&sort=title&filter[my-hubs]=true', {
        headers: {
            'Content-Type': 'application/vnd.api+json',
        },
    })
}
export function getHubsWorkflow(spaceID) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceID + '/hubs?sort=title&filter[is-booster]]=true', {
        headers: {
            'Content-Type': 'application/vnd.api+json',
        },
    })
}
export function getOpenHubsWorkflow(spaceID) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceID + '/hubs?sort=title&filter[is-booster]]=true&filter[is-open]]=true', {
        headers: {
            'Content-Type': 'application/vnd.api+json',
        },
    })
}


export function getHub(hubId) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/hubs/' + hubId, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function updateHub(hubId, data) {
    return axios.patch(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/hubs/' + hubId, data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

//endpoint that exclude activities which are already added in the group.
export function getActivitiesNotAddedToHub(hubId, size, page) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/hubs/' + hubId + '/-actions/excluded-activities?page[size]=' + size + '&page[number]=' + page, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function getActivitiesNotAddedToHubWithKeyword(hubId, size, page, keyword) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/hubs/' + hubId + '/-actions/excluded-activities?page[size]=' + size + '&page[number]=' + page + '&keyword=' + keyword, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function addActivitiesToHub(hubId, data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/hubs/' + hubId + '/-actions/add-activities', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        }
    })
}

//activities which are already added in the group.
export function getActivitiesToHub(hubId, size, page) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/hubs/' + hubId + '/-actions/get-activities?page[size]=' + size + '&page[number]=' + page, {

        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

//search activities,attachments and links which are added in the Hub.
export function searchItemsHub(hubId, keyword) {
    keyword = encodeURIComponent(keyword)
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/hubs/' + hubId + '/hub-feed-items?filter[keyword]=' + keyword, {

        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

//Remove activity from Hub
export function deleteHubActivity(hubId, data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/hubs/' + hubId + '/-actions/remove-activities', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function getHubSharingSetings() {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/sharing-settings?filter[for-hubs]=true', {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function getSharedHubs(spaceID, page, size) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceID + '/hubs?page[size]=' + size + '&page[number]=' + page + '&sort=title&filter[shared-hubs]=true', {
        headers: {
            'Content-Type': 'application/vnd.api+json',
        },
    })
}
export function getPeopleInHub(hubId, page, size) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/hubs/' + hubId + '/-actions/get-users?filter[regular-members]=true&page[size]=' + size + '&page[number]=' + page, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function getBoostersInHub(hubId, page, size) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/hubs/' + hubId + '/-actions/get-users?filter[boosters]=true&page[size]=' + size + '&page[number]=' + page, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function removeUserFromHub(hubId, data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/hubs/' + hubId + '/-actions/remove-user', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function removeUsersFromHub(hubId, data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/hubs/' + hubId + '/-actions/remove-users', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function addHubBoosters(hubId, data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/hubs/' + hubId + '/-actions/add-boosters', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function searchSpaceBoostersHubExcluded(spaceId, hubId, searchTerm) {
    searchTerm = encodeURIComponent(searchTerm)
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceId + '/-actions/get-users?page[size]=500&filter[boosters-excluded-from-hub]=' + hubId + '&keyword=' + searchTerm, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function shareHub(hubId, data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/hubs/' + hubId + '/-actions/share-hub', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function checkUserInHub(hubId, data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/hubs/' + hubId + '/-actions/check-hub-user', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function checkUserInSpace(hubId, data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/hubs/' + hubId + '/-actions/check-independent-user', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function getAllHubs(spaceID, page, size) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceID + '/hubs?page[size]=' + size + '&page[number]=' + page + '&sort=title', {
        headers: {
            'Content-Type': 'application/vnd.api+json',
        },
    })
}
//get hubs for the search in the Dashboard
export function searchHubsDashborad(spaceID, size, keyword) {
    keyword = encodeURIComponent(keyword)
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceID + '/hubs?page[size]=' + size + '&filter[keyword]=' + keyword, {
        headers: {
            'Content-Type': 'application/vnd.api+json',
        },
    })
}

export function updateHubActivityRelationship(hubId, data) {
    return axios.patch(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/hubs/' + hubId + '/-actions/edit-activity-relationships', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function searchPeopleInHubMembers(hubId, searchTerm, page, size) {
    searchTerm = encodeURIComponent(searchTerm)
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/hubs/' + hubId + '/-actions/get-users?filter[regular-members]=true&page[size]=' + size + '&page[number]=' + page + '&keyword=' + searchTerm, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function searchPeopleOwnersInHub(hubId, searchTerm, page, size) {
    searchTerm = encodeURIComponent(searchTerm)
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/hubs/' + hubId + '/-actions/get-users?filter[boosters]=true&page[size]=' + size + '&page[number]=' + page + '&keyword=' + searchTerm, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function uploadHubFile(hubId, data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/hubs/' + hubId + '/-actions/doc-upload', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function removeHubFile(hubId, data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/hubs/' + hubId + '/-actions/remove-file', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function addHubAttachment(data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/hub-attachments', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function getHubItems(hubId, size, page) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/hubs/' + hubId + '/hub-feed-items?page[size]=' + size + '&page[number]=' + page, {

        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function deleteHubAttachment(hubAttachmentId) {
    return axios.delete(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/hub-attachments/' + hubAttachmentId, {
        headers: {
            'Content-Type': 'application/vnd.api+json',
            'Accept': 'application/vnd.api+json'
        },
    })
}
export function addHubLink(data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/hub-links', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function deleteHubLink(hubLinkId) {
    return axios.delete(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/hub-links/' + hubLinkId, {
        headers: {
            'Content-Type': 'application/vnd.api+json',
            'Accept': 'application/vnd.api+json'
        },
    })
}
export function updateHubAttachment(hubAttachmentId, data) {
    return axios.patch(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/hub-attachments/' + hubAttachmentId, data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function updateHubLink(hubLinkId, data) {
    return axios.patch(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/hub-links/' + hubLinkId, data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function createHubCategory(data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/hub-categories', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        }
    })
}

export function getHubItemsWithoutCategory(hubId, size, page) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/hubs/' + hubId + '/hub-feed-items?filter[categoryId]=&page[size]=' + size + '&page[number]=' + page, {

        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function getAllHubItemsWithoutCategory(hubId) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/hubs/' + hubId + '/hub-feed-items?filter[categoryId]=', {

        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function getHubCategories(hubId) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/hubs/' + hubId + '/hub-feed-items?filter[categories]=true', {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function deleteHubCategory(hubCategoryId) {
    return axios.delete(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/hub-categories/' + hubCategoryId, {
        headers: {
            'Content-Type': 'application/vnd.api+json',
            'Accept': 'application/vnd.api+json'
        },
    })
}

export function updateHubCategory(hubCategoryId, data) {
    return axios.patch(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/hub-categories/' + hubCategoryId, data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function changeHubItemCategory(id, data) {
    return axios.patch(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/hub-feed-items/' + id + '/-actions/add-to-category', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function getHubCategory(hubCategoryId) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/hub-categories/' + hubCategoryId, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function getCategoryItems(hubId, hubCategoryId, size, page) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/hubs/' + hubId + '/hub-feed-items?filter[categoryId]=' + hubCategoryId + '&page[size]=' + size + '&page[number]=' + page, {

        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function getAllCategoryItems(hubId, hubCategoryId) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/hubs/' + hubId + '/hub-feed-items?filter[categoryId]=' + hubCategoryId, {

        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function reorderCategories(id, data) {
    return axios.patch(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/hubs/' + id + '/-actions/reorder-hub-feed-items?filter[reorder-categories]=true', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function reorderHubItemsWithoutCategory(id, data) {
    return axios.patch(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/hubs/' + id + '/-actions/reorder-hub-feed-items', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function reorderItemsInCategory(hubId, hubCategoryId, data) {
    return axios.patch(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/hubs/' + hubId + '/-actions/reorder-hub-feed-items?filter[category]=' + hubCategoryId, data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}
export function getUserHubAccess(spaceID, page, size, userID) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceID + '/hubs?page[size]=' + size + '&page[number]=' + page + '&sort=title&filter[access-for-user]=' + userID, {
        headers: {
            'Content-Type': 'application/vnd.api+json',
        },
    })
}
export function getUserHubAccessWithRoleFilter(spaceID, page, size, userID, role) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceID + '/hubs?page[size]=' + size + '&page[number]=' + page + '&sort=title&filter[access-for-user]=' + userID + '&filter-by-role=' + role, {
        headers: {
            'Content-Type': 'application/vnd.api+json',
        },
    })
}
export function searchHubsIsBooster(spaceID, keyword) {
    keyword = encodeURIComponent(keyword)
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceID + '/hubs?filter[is-booster]=true&filter[keyword]=' + keyword, {
        headers: {
            'Content-Type': 'application/vnd.api+json',
        },
    })
}

export function getHubsIsBooster(spaceID, size) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceID + '/hubs?filter[is-booster]=true&page[size]=' + size, {
        headers: {
            'Content-Type': 'application/vnd.api+json',
        },
    })
}

export function createRequestToBecomeOwner(data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/requests-owner-rights/', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function getRequestToBecomeOwner(requestId) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/requests-owner-rights/' + requestId, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function updateRequestToBecomeOwner(requestId, data) {
    return axios.patch(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/requests-owner-rights/' + requestId, data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}